import React from 'react';
import { Container, Card, Form, Button, Image } from 'react-bootstrap';
import MailchimpSubscribe from 'react-mailchimp-subscribe';
import './SignUpSheet.css';

const SignUpSheet = () => {
  const postURL = `https://decisionnetwork.us21.list-manage.com/subscribe/post?u=${process.env.REACT_APP_U_VALUE}&amp;id=${process.env.REACT_APP_ID_VALUE}&amp;f_id=${process.env.REACT_APP_FID_VALUE}`; // Replace with your Mailchimp endpoint

  return (
    <Container className="d-flex justify-content-center mt-5 vertical-align">
      <Image className="decision-logo" src="/decision-logo.png" />
        <Card.Header className="header" as="h4">WELCOME</Card.Header>
        <Card.Body>
          <MailchimpSubscribe
            url={postURL}
            render={({ subscribe, status, message }) => {
              return (
                <Form
                className="decision-signup"
                onSubmit={(e) => {
                  e.preventDefault();

                  const email = e.target.email.value;
                  const firstName = e.target.firstName.value;
                  const lastName = e.target.lastName.value;

                  // For radio buttons, you can find the checked one with a filter
                  const roleRadio = Array.from(e.target.role).find((radio) => radio.checked);
                  const role = roleRadio ? roleRadio.value : null;  // 'commentator' or 'producer' or null

                  if (role === '1') {
                    subscribe({
                      EMAIL: email,
                      FNAME: firstName,
                      LNAME: lastName,
                      'group[1643][1]': role
                    });
                  }
                  else if (role === '2') {
                    subscribe({
                        EMAIL: email,
                        FNAME: firstName,
                        LNAME: lastName,
                        'group[1643][2]': role
                    });
                  }
              }}
                >
                  <Form.Group className="first-name-group" controlId="formFirstName">
                    <Form.Label className="entry-text">First Name</Form.Label>
                    <Form.Control className="entry-field" type="text" placeholder="Enter first name" name="firstName" />
                  </Form.Group>

                  <Form.Group className="last-name-group" controlId="formLastName">
                    <Form.Label className="entry-text">Last Name</Form.Label>
                    <Form.Control className="entry-field" type="text" placeholder="Enter last name" name="lastName" />
                  </Form.Group>

                  <Form.Group className="email-group" controlId="formEmail">
                    <Form.Label className="entry-text">Email address</Form.Label>
                    <Form.Control className="entry-field" type="email" placeholder="Enter email" name="email" />
                    <Form.Text className="text-muted entry-text">
                      We'll never share your email with anyone else.
                    </Form.Text>
                  </Form.Group>

                  <Form.Group className="radio-group">
                    <Form.Check
                      className="radio-button"
                      type="radio"
                      label="I am a commentator looking for opportunities"
                      name="role"
                      value="1"
                      id="roleCommentator"
                    />
                    <Form.Check
                      className="radio-button"
                      type="radio"
                      label="I am a producer looking to post media opportunities."
                      name="role"
                      value="2"
                      id="roleProducer"
                    />
                  </Form.Group>

                  <Button className="submit-button" variant="primary" type="submit">
                    <b>Subscribe</b>
                  </Button>

                  <div className="status">
                    {status === "sending" && <div style={{ color: "blue" }}>sending...</div>}
                    {status === "error" && <div style={{ color: "red" }}> An error occurred. Please check you filled all fields correctly and try again.</div>}
                    {status === "success" && <div style={{ color: "green" }}>Subscribed!</div>}
                  </div>
                </Form>
              );
            }}
          />
        </Card.Body>
    </Container>
  );
};

export default SignUpSheet;
